import { SLOT_STATE } from '../constants';
const SLOT_STATE_REGEXP = new RegExp(/-(?=[^-]*$)/);
export const extractSlotState = (slot) => {
    const [slotId, slotState] = slot.split(SLOT_STATE_REGEXP);
    const isState = Object.values(SLOT_STATE).includes(slotState);
    return {
        slotId: isState ? slotId : slot,
        slotState: isState ? slotState : '',
    };
};
//# sourceMappingURL=extractSlotsState.js.map